import React from "react";
import "../template-file-css/document-file-template.css";

export const NBT_CrisisPlan = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NBT_CrisisPlan' className='file-pdf-document'>
            <div className='file-template'>

                <h3>
                    Unified Crisis/Safety Plan
                </h3>
                <h4>Natural Supports and Agencies Involved
                </h4>
                <table>
                    <tr>
                        <td className="w-250">
                            <span className="eleHeader">Name</span>
                        </td>
                        <td className="w-250">
                            <span className="eleHeader">Contact Name and Title</span>
                        </td>
                        <td className="w-250">
                            <span className="eleHeader">Phone number</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="text" id="txtName" name="txtName" className="add-only" />
                        </td>
                        <td className="w-250">
                            <input type="text" id="txtContactName" name="txtContactName" className="add-only" />
                        </td>
                        <td className="w-250">
                            <input type="text" id="txtPhone" name="txtPhone" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="text" id="txtName1" name="txtName1" className="add-only" />
                        </td>
                        <td className="w-250">
                            <input type="text" id="txtContactName1" name="txtContactName1" className="add-only" />
                        </td>
                        <td className="w-250">
                            <input type="text" id="txtPhone1" name="txtPhone1" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="text" id="txtName2" name="txtName2" className="add-only" />
                        </td>
                        <td className="w-250">
                            <input type="text" id="txtContactName2" name="txtContactName2" className="add-only" />
                        </td>
                        <td className="w-250">
                            <input type="text" id="txtPhone2" name="txtPhone2" className="add-only" />
                        </td>
                    </tr>
                </table>
                <h4>Crisis/Safety Plan
                </h4>
                <table>
                    <tr>
                        <td className="w-250">
                            <span className="eleHeader">Crisis Triggers</span>
                        </td>
                        <td className="w-250">
                            <span className="eleHeader">Describe Needed Response</span>
                        </td>
                        <td className="w-250">
                            <span className="eleHeader">Responsible Person/s </span><span className="small block">(name/phone)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">Home
                        </td>
                        <td className="w-250">Client's Response
                        </td>
                        <td className="w-250">&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">1.
                            <input type="text" id="txtCrisisTriggers" name="txtCrisisTriggers" className="add-only" />
                        </td>
                        <td className="w-250">1.<input type="text" id="txtDescribeNeeded" name="txtDescribeNeeded" className="add-only" />
                        </td>
                        <td className="w-250">1.<input type="text" id="txtResponsiblePerson" name="txtResponsiblePerson" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">2.
                            <input type="text" id="txtCrisisTriggers1" name="txtCrisisTriggers1" className="add-only" />
                        </td>
                        <td className="w-250">2.<input type="text" id="txtDescribeNeeded1" name="txtDescribeNeeded1" className="add-only" />
                        </td>
                        <td className="w-250">2.<input type="text" id="txtResponsiblePerson1" name="txtResponsiblePerson1" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">3. <input type="text" id="txtCrisisTriggers2" name="txtCrisisTriggers2" className="add-only" />
                        </td>
                        <td className="w-250">3.<input type="text" id="txtDescribeNeeded2" name="txtDescribeNeeded2" className="add-only" />
                        </td>
                        <td className="w-250">3.<input type="text" id="txtResponsiblePerson2" name="txtResponsiblePerson2" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">Community
                        </td>
                        <td className="w-250">Client's Response
                        </td>
                        <td className="w-250">&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">1.
                            <input type="text" id="txtCrisisTriggers3" name="txtCrisisTriggers3" className="add-only" />
                        </td>
                        <td className="w-250">1.<input type="text" id="txtDescribeNeeded3" name="txtDescribeNeeded3" className="add-only" />
                        </td>
                        <td className="w-250">1.<input type="text" id="txtResponsiblePerson3" name="txtResponsiblePerson3" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">2.
                            <input type="text" id="txtCrisisTriggers4" name="txtCrisisTriggers4" className="add-only" />
                        </td>
                        <td className="w-250">2.<input type="text" id="txtDescribeNeeded4" name="txtDescribeNeeded4" className="add-only" />
                        </td>
                        <td className="w-250">2.<input type="text" id="txtResponsiblePerson4" name="txtResponsiblePerson4" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">3.
                            <input type="text" id="txtCrisisTriggers5" name="txtCrisisTriggers5" className="add-only" />
                        </td>
                        <td className="w-250">3.<input type="text" id="txtDescribeNeeded5" name="txtDescribeNeeded5" className="add-only" />
                        </td>
                        <td className="w-250">3.<input type="text" id="txtResponsiblePerson5" name="txtResponsiblePerson5" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">Other
                        </td>
                        <td className="w-250">Client's Response
                        </td>
                        <td className="w-250">&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">1.
                            <input type="text" id="txtCrisisTriggers6" name="txtCrisisTriggers6" className="add-only" />
                        </td>
                        <td className="w-250">1.<input type="text" id="txtDescribeNeeded6" name="txtDescribeNeeded6" className="add-only" />
                        </td>
                        <td className="w-250">1.<input type="text" id="txtResponsiblePerson6" name="txtResponsiblePerson6" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">2.
                            <input type="text" id="txtCrisisTriggers7" name="txtCrisisTriggers7" className="add-only" />
                        </td>
                        <td className="w-250">2.<input type="text" id="txtDescribeNeeded7" name="txtDescribeNeeded7" className="add-only" />
                        </td>
                        <td className="w-250">2.<input type="text" id="txtResponsiblePerson7" name="txtResponsiblePerson7" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">3.
                            <input type="text" id="txtCrisisTriggers8" name="txtCrisisTriggers8" className="add-only" />
                        </td>
                        <td className="w-250">3.<input type="text" id="txtDescribeNeeded8" name="txtDescribeNeeded8" className="add-only" />
                        </td>
                        <td className="w-250">3.<input type="text" id="txtResponsiblePerson8" name="txtResponsiblePerson8" className="add-only" />
                        </td>
                    </tr>
                </table>
                <h3>Crisis/Safety Plan Agreement
                </h3>
                <p>
                    I &nbsp; <input type="text" id="txtSafetyPlan" name="txtSafetyPlan" className="add-only" /> &nbsp; have participated in the development of my crisis/safety plan and I have partnered with New Beginnings Today in the development of these crisis/safety plan on my choices, preferences, and desired outcomes.
                </p>
                <table>
                    <tr>
                        <td className="w-200  signature">&nbsp;</td>
                        <td className="w-150  signature">&nbsp;</td>
                        <td className="w-200  signature">&nbsp;</td>
                        <td className="w-150  signature">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-200 small">Client Signature</td>
                        <td className="w-150 small">Date</td>
                        <td className="w-200 small">NBT Staff</td>
                        <td className="w-150 small">Date</td>
                    </tr>
                </table>
            </div>
        </form>
    )
}